/* 布局 */
//前台
import Layout from "@views/layout";

const expertdataRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "expertdata",
            name: "EXPERTDATA",
            meta: {
                title: "首页专家数据管理",
                sort: 1,
            },
            component: () => import("@views/business/expertdata/index.vue"),
            redirect: {
                name: "EXPERTDATA_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EXPERTDATA_LIST",
                    meta: {
                        title: "首页专家数据管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/expertdata/list.vue"),
                },
                                {
                    path: "add",
                    name: "EXPERTDATA_ADD",
                    meta: {
                        title: "新增驻站专家/MVP统计数据配置表",
                        parentPath: '/business/expertdata/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertdata/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "EXPERTDATA_EDIT",
                    meta: {
                        title: "编辑驻站专家/MVP统计数据配置表",
                        parentPath: '/business/expertdata/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertdata/form.vue"),
                },
                                        ],
    },


        ],
};

export default expertdataRouter;
